"use strict";
function shallowEqual(objA, objB) {
    if (!objA || !objB)
        return true;
    if (objA === objB)
        return true;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length)
        return false;
    var hasOwn = Object.prototype.hasOwnProperty;
    for (var i = 0; i < keysA.length; i++) {
        if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
            return false;
        }
    }
    return true;
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = shallowEqual;
//# sourceMappingURL=shallowEqual.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-apollo/lib/shallowEqual.js
// module id = 881
// module chunks = 0 1 3